import Strozzi1 from '../../../media/Residentials/Strozzi/Strozzi.webp'
import Strozzi2 from '../../../media/Residentials/Strozzi/Strozzi (2).webp'
import Strozzi3 from '../../../media/Residentials/Strozzi/Strozzi (3).webp'
import Strozzi4 from '../../../media/Residentials/Strozzi/Strozzi (4).webp'
import Strozzi5 from '../../../media/Residentials/Strozzi/Strozzi (5).webp'
import Strozzi6 from '../../../media/Residentials/Strozzi/Strozzi (6).webp'
import Strozzi7 from '../../../media/Residentials/Strozzi/Strozzi (7).webp'
import Strozzi8 from '../../../media/Residentials/Strozzi/Strozzi (8).webp'
import Strozzi9 from '../../../media/Residentials/Strozzi/Strozzi (9).webp'
import Strozzi10 from '../../../media/Residentials/Strozzi/Strozzi (10).webp'
import Strozzi11 from '../../../media/Residentials/Strozzi/Strozzi (11).webp'
import Strozzi12 from '../../../media/Residentials/Strozzi/Strozzi (12).webp'
import Strozzi13 from '../../../media/Residentials/Strozzi/Strozzi (13).webp'



const Strozziimages =[
Strozzi1,Strozzi2,Strozzi3,Strozzi4,Strozzi5,Strozzi6,Strozzi7,Strozzi8,Strozzi9,Strozzi10,Strozzi11,Strozzi12,Strozzi13
]

export default Strozziimages;